// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__qwHFL","logo":"MainHeader_logo__D72mJ","nav":"MainHeader_nav__O599A","active":"MainHeader_active__nOEzl"};